import { Modal, ModalContent, ModalOverlay, Spinner } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
  isLoading: boolean;
}

const FullScreenLoader: FC<Props> = ({ isLoading }) => {
  return (
    <Modal isOpen={isLoading} onClose={() => {}} isCentered>
      <ModalOverlay />
      <ModalContent w={10} h={10} justifyContent="center" alignItems="center">
        <Spinner />
      </ModalContent>
    </Modal>
  );
};

export default FullScreenLoader;
